import type { Persona } from "./persona";

/**
 * Personas allowed to open the employee create/edit screens.
 *
 * The API requires ``IsAccountAdmin`` for employee create, update and delete
 * (apps/api/v1/core/employee_views.py). The owner persona also represents a
 * legacy admin login, so it is the only frontend persona with that authority.
 * Managers still see the employee register, but only as a team-scoped reader.
 */
export const EMPLOYEE_WRITE_PERSONAS: Persona[] = ["owner"];

/**
 * Personas allowed to open the workforce reports screen.
 *
 * Managers are deliberately excluded: ReportsPage reads the account-wide
 * payroll-run list, and PayrollRunViewSet is not team-scoped. Exposing the page
 * to managers would widen their visibility of company payroll totals merely to
 * make a menu entry visible. An employee's report stays self-scoped through the
 * employee directory API, so it remains safe.
 */
export const WORKFORCE_REPORT_PERSONAS: Persona[] = ["owner", "employee"];
